<img
  class="entity-logo d-block"
  src="{{ src }}"
  [ngClass]="{ 'entity-logo--small': small }"
  alt="entity-logo"
/>
